export const PLANNER_QUOTE_STATES = [
    { id: "draft", label: "Rough draft", blurb: "Scope is open. Change anything." },
    { id: "finalized", label: "Finalized", blurb: "Ready to quote. Scope can still move." },
    { id: "quoted", label: "Quote generated", blurb: "Locked to the last generated quote." },
    { id: "revised", label: "Revised", blurb: "New revision unlocked for changes." },
];

export function quoteStateOf(value) {
    const id = String(value || "").trim().toLowerCase();
    return PLANNER_QUOTE_STATES.some((row) => row.id === id) ? id : "draft";
}

export function quoteStateLabel(id) {
    return PLANNER_QUOTE_STATES.find((row) => row.id === id)?.label || "Rough draft";
}

export function quoteStateColor(id) {
    const map = {
        draft: "default",
        finalized: "info",
        quoted: "success",
        revised: "warning",
    };
    return map[quoteStateOf(id)] || "default";
}

export function isQuoteLockedState(state) {
    return quoteStateOf(state) === "quoted";
}

export function workStatusComplete(status) {
    return status === "done" || status === "dropped";
}

export function jobQuoteLocked(job) {
    return Boolean(job && isQuoteLockedState(job.quoteState));
}

export function quoteRevLabel(rev) {
    return `Rev ${Math.max(1, Number(rev) || 1)}`;
}
